import { PurchaseButtonAlternate, SoldOutText } from 'components/button/button.styled'
import { useEventSelector } from 'hooks/user/useEvents'
import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { EventDetails, EventType } from 'types/Event'
import { calculateIsSoldOut, formatDateText } from 'utils/event'

import {
    AnimatedEventDetails,
    ButtonWrapper,
    Container,
    SelectButton,
    SelectEventText,
    SelectEventTextSmall,
    SelectEventWrapper,
    SelectWithButtonWrapper,
    StyledSelect,
    WrapperRow,
} from './index.style'

interface Props {
    currentEvent: EventDetails
    events: EventType[]
    title: string
    redirectUrl: string
    topPurchaseButton?: boolean
    openByDefault?: boolean
}
export const ShowEventSelector = ({
    currentEvent,
    events,
    title,
    redirectUrl,
    topPurchaseButton = false,
    openByDefault = false,
}: Props) => {
    const navigate = useNavigate()
    const {
        selectedEventId,
        setSelectedEventId,
        selectedLocation,
        setSelectedLocation,
        showDetails,
        handleToggleDetails,
        filteredEventsByLocation,
        selectedEventData,
        locationOptions,
        eventDetails,
    } = useEventSelector(currentEvent, events)

    const handleBuying = useCallback(
        (eventId: string) => {
            setSelectedEventId(eventId)
            navigate(`${redirectUrl}/${eventId}`)
        },
        [navigate, redirectUrl, setSelectedEventId],
    )

    const detailsVisible = openByDefault ? true : showDetails

    return (
        <Container>
            <WrapperRow>
                {!topPurchaseButton && selectedEventData && (
                    <SelectEventText>
                        <strong>{`${title}: `}</strong>
                        {formatDateText(selectedEventData.event_date)}
                        <br />
                        {selectedEventData.location?.name}
                        {selectedEventData.location?.address && (
                            <>
                                <br />
                                {selectedEventData.location.address}
                            </>
                        )}
                    </SelectEventText>
                )}
                {selectedEventId && detailsVisible && (
                    <SelectWithButtonWrapper>
                        <SelectEventText>Válasszon helyszínt:</SelectEventText>
                        <StyledSelect value={selectedLocation} options={locationOptions} onChange={(e) => setSelectedLocation(e.value)} />
                        {!openByDefault && <SelectButton icon="pi pi-angle-down" onClick={handleToggleDetails} />}
                    </SelectWithButtonWrapper>
                )}

                {topPurchaseButton && !detailsVisible && (
                    <ButtonWrapper>
                        {selectedEventData && (
                            <PurchaseButtonAlternate onClick={() => handleBuying(selectedEventData.event_id)}>
                                Jegyvásárlás
                            </PurchaseButtonAlternate>
                        )}
                        {!openByDefault && <SelectButton icon="pi pi-angle-down" onClick={handleToggleDetails} />}
                    </ButtonWrapper>
                )}
            </WrapperRow>

            {detailsVisible && (
                <AnimatedEventDetails display={detailsVisible}>
                    {filteredEventsByLocation.map((event: any) => {
                        const eventDate = eventDetails[event.event_id]?.event_date
                        const eventData = eventDetails[event.event_id]
                        const isSoldOut = eventData?.location ? calculateIsSoldOut(eventData.location, eventData.tickets ?? []) : false
                        const sellingDateIsOverDue =
                            eventData && eventData.selling_end_date ? new Date(eventData.selling_end_date) < new Date() : false

                        return (
                            <SelectEventWrapper key={event.event_id}>
                                <SelectEventTextSmall>
                                    <strong>{eventDate && formatDateText(eventDate)} </strong>
                                </SelectEventTextSmall>
                                {sellingDateIsOverDue ? (
                                    <SoldOutText>Az értékesítés lezárult!</SoldOutText>
                                ) : isSoldOut ? (
                                    <SoldOutText>Minden jegy elkelt!</SoldOutText>
                                ) : (
                                    <PurchaseButtonAlternate onClick={() => handleBuying(event.event_id)}>
                                        Jegyvásárlás
                                    </PurchaseButtonAlternate>
                                )}
                            </SelectEventWrapper>
                        )
                    })}
                </AnimatedEventDetails>
            )}
        </Container>
    )
}
